<template lang="pug">
v-card
  v-toolbar(
    height="40"
    color="cyan"
    dark)
    v-toolbar-title Información adicional del predio
  //- div(v-if="currentSearch.registros")
  //-   v-card-subtitle(class="pt-2 pb-0") Tipo Predio
  //-   v-card-text(class="text--primary text-h4")
  //-     div {{currentSearch.tipo_predio}}

  //-   v-card-subtitle(class="pt-2 pb-0") Direccion
  //-   v-card-text(class="text--primary text-h6") {{currentSearch.registros.direccion}}

  //-   v-card-subtitle(class="pt-2 pb-0") Código catastral
  //-   v-card-text(class="text--primary text-h6") {{currentSearch.registros.numero_predial_nacional}}

  //-   v-card-subtitle(class="pt-2 pb-0") Municipio
  //-   v-card-text(class="text--primary text-h6") {{currentSearch.registros.municipio}}
  //- div(v-else class="my-3 text-center")
  //-   span(class="text-h6") No se encontro información de registros 1.
  //- Infomación de registros 1
  div(v-if="currentSearch.registros_1 || currentSearch.registros_2")
    v-card-subtitle(class="pt-2 pb-0") Vigencia Registros
    v-card-text(class="text--primary text-h4")
      div {{currentSearch.records_base}}
    div(v-if="Object.keys(currentSearch.registros_1).length > 0")
      v-divider
      v-card-text(class="pt-2 pb-0 text-h6") REGISTROS 1
      v-data-table(
        dense
        :headers="recordOneHeaders"
        :items="[processedRecorsOne]"
        item-key="NUMERO_DEL_PREDIO"
        class="ma-2 elevation-1")
        template(v-slot:item.DESTINO_ECONOMICO="{ item }")
          span( v-html="item.DESTINO_ECONOMICO")
        
    div(v-else class="my-3 text-center")
      span(class="text-h6 red--text") No se encontro información de registros 1.
    //- Infomación de registros 2
    div(v-if="currentSearch.registros_2.length > 0")
      v-divider
      v-card-text(class="pt-2 pb-0 text-h6") REGISTROS 2
      v-data-table(
        dense
        :headers="recordTwoHeaders"
        :items="processedRecorsTwo"
        item-key="NUMERO_DEL_PREDIO"
        class="ma-2 elevation-1")
        template(v-slot:item.ZONA_FISICA_1="{ item }")
          span( v-html="item.ZONA_FISICA_1")
        template(v-slot:item.ZONA_FISICA_2="{ item }")
          span( v-html="item.ZONA_FISICA_2")
        template(v-slot:item.ZONA_ECONOMICA_1="{ item }")
          span( v-html="item.ZONA_ECONOMICA_1")
        template(v-slot:item.ZONA_ECONOMICA_2="{ item }")
          span( v-html="item.ZONA_ECONOMICA_2")
        template(v-slot:item.USO_1="{ item }")
          span( v-html="item.USO_1")
        template(v-slot:item.USO_2="{ item }")
          span( v-html="item.USO_2")
        template(v-slot:item.USO_3="{ item }")
          span( v-html="item.USO_3")
        template(v-slot:item.TIPIFICACION_1="{ item }")
          span( v-html="item.TIPIFICACION_1")
        template(v-slot:item.TIPIFICACION_2="{ item }")
          span( v-html="item.TIPIFICACION_2")
        template(v-slot:item.TIPIFICACION_3="{ item }")
          span( v-html="item.TIPIFICACION_3")
    div(v-else class="my-3 text-center")
      span(class="text-h6 red--text") No se encontro información de registros 2.
  div(v-else class="my-3 text-center")
    span(class="text-h6") No se encontro información de registros 1 o 2.
</template>

<script>
import { mapState } from 'vuex';
import { processRecordsOne, processRecordsTwo } from '@/utils';

export default {
  name: 'RecordOneInfo',

  computed: {
    ...mapState('folios', ['currentSearch']),
    ...mapState('cadastral', [
      'economicDestinations',
      'constructionUses',
      'typologyUses',
      'physicalZones',
      'economicZones',
    ]),
    recordOneHeaders() {
      return Object.keys(this.currentSearch.registros_1).map((x) => {
        const data = {};
        data.text = x;
        data.value = x;
        return data;
      })
    },
    recordTwoHeaders() {
      return Object.keys(this.currentSearch.registros_2[0]).map((x) => {
        const data = {};
        data.text = x;
        data.value = x;
        return data;
      })
    },
    // propiedad computada para obtener los datos de registros 1 procesados
    processedRecorsOne() {
      if (this.currentSearch === null) return;
      return processRecordsOne(this.currentSearch.registros_1, this.economicDestinations);
    },
    // propiedad computada para obtener los datos de registros 2 procesados
    processedRecorsTwo() {
      if (this.currentSearch === null) return;
      return processRecordsTwo(
        this.currentSearch.registros_2,
        this.constructionUses,
        this.typologyUses,
        this.physicalZones,
        this.economicZones);
    }
  }
}
</script>
  